module.exports = __webpack_public_path__ + "static/media/ent-image1@2x.9d6c5dd1.png";